
export const MuiModal = {
    styleOverrides: {
        root: {
          position: 'absolute'
        },
    }
}
